
import { SyncStation } from 'shared/api/api';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import actionCreatorFactory from 'typescript-fsa';
import * as types from './types';

const actionCreator = actionCreatorFactory(GenActionFactoryName('station'));
export const getSyncStationData = actionCreator.async<{siteId: string, activeSiteId?: string}, SyncStation>(types.GET_StationData);